/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import useScroll from "../hooks/useScroll";

const BackToTopButton = () => {
	const scroll = useScroll();

	return (
		<div className={`back-top-top ${scroll > 1000 ? "active" : ""}`}>
			<a href="#">
				<img src={process.env.PUBLIC_URL + "/img/arrow.png"} alt="" /> Back to Top
			</a>
		</div>
	);
};

export default BackToTopButton;
